import { render, staticRenderFns } from "./Reci.vue?vue&type=template&id=cd0724ba&scoped=true"
import script from "./Reci.vue?vue&type=script&lang=js"
export * from "./Reci.vue?vue&type=script&lang=js"
import style0 from "./Reci.vue?vue&type=style&index=0&id=cd0724ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0724ba",
  null
  
)

export default component.exports